import {Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {NetworkServerGroupModel} from "../../models/network-server-group.model";
import {Location} from '@angular/common';
import {Router} from "@angular/router";
import {NgForm} from "@angular/forms";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Output} from "@angular/core";
import { NgxSelectModule, NgxSelectComponent, INgxSelectOptions } from 'ngx-select-ex';
import {ApiEndpoints} from "../../services/api-endpoints";

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-create-ns-groups',
  templateUrl: './create-ns-groups.component.html',
})
export class CreateNsGroupsComponent implements OnInit {

  public networkServerGroupModel: NetworkServerGroupModel;
  public noValid: boolean = false;
  public noValidNsId: boolean = false;
  public nameExist;
  public disableName = false;
  public disableNsId = false;
  public netIdExist = false;
  public nsIdExist = false;
  public disableSaveButton = false;
  public duplicatesExist = false;
  public duplicateError = false;
  public searchText = '';
  public trackingPattern: any[] = [];
  public showSearch = false;
  public showPrimarySearch = false;
  public showSecondarySearch = false;
  public visibleAnimate = false;
  public hasError = false;
  public trackingArr = [];
  public trackingCheck = [];
  public patternError = false;
  public doNotHaveNetId = true;
  public allPlatforms: any[] = [];
  public protocolVersions: string[] = ['1.1']

  public username = "";
  public userId = "";
  public ownerArray:Array<string> = [];

  public class = ["ng-valid", "ng-touched", "ng-dirty"];
  public errorClass = ["ng-pristine", "ng-invalid", "ng-touched"];

  @Input() validationType;
  @Input() dataType;
  @ViewChild('inputNetId') inputNetId: ElementRef;
  @ViewChild('validate') validate: NgForm;

  constructor(private router: Router,
              private _location: Location,
              private http: HttpClient) {
    this.networkServerGroupModel = new NetworkServerGroupModel();
  }

  // Live Search functions
  public selectedOwner(value:any):void {
    this.networkServerGroupModel.owner = value.split(",", 1)[0] ;
  }

  public removedOwner(value:any):void {
    this.networkServerGroupModel.owner = "";
  }

  public selectedProtocolVersion(value:any): void {
    this.networkServerGroupModel.protocolVersion = value.split(",", 1)[0];
  }

  private hex2bin(hex: string, length = 64) {
    var mask = "";
      if(hex.length == 16) {
        mask = "0000000000000000000000000000000000000000000000000000000000000000";
        if(!length) length = 64;
      } else {
        mask = "000000000000000000000000";
        if(!length) length = 24;
      }
    var hexAsBinary = parseInt(hex, 16).toString(2);
    var hexAsBinaryStr = (mask + hexAsBinary).substr(-mask.length);
    var binStr = hexAsBinaryStr.substr(0, length);
    return binStr;
  }

  // Validation fields
  trimValue(event) {
    event.target.value = event.target.value.replace(/\s\s+/g, ' ');
  }

  validateNsId(nsId, nsIdElement) {
    // Pattern validation
    let nsIdRegExp = new RegExp(/^([0-9a-fA-F]{16})$/i);
    if (!nsIdRegExp.test(nsId) || nsId.length > 16) {
      this.noValidNsId = true;
    } else {
      this.noValidNsId = false;
    }
    if(!this.noValidNsId) {
      this.nsIdExist = false;
      // Verify if NsId exists in database
      let headers = new HttpHeaders({'Content-Type': 'application/json'});
      let options =  {headers: headers}
      var url = ApiEndpoints.EXISTS_NSID;
      nsId = nsId.trim();
      var body: any = {
        "virtId": "0",
        "nsId": nsId
      };
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.nsIdExist = data.response;
          }
        );
    }
  }

  validateName(name, nameElement) {
    this.nameExist = false;
    nameElement.classList.remove(...this.class);

    if(name.trim().length == 0){
      this.disableName = true;
      nameElement.classList.remove(this.class);
      nameElement.classList.add(this.errorClass);
    } else {
      let headers = new HttpHeaders({'Content-Type': 'application/json'});
      let options = {headers: headers};
      var url = ApiEndpoints.EXISTS_NAME;
      name = name.replace(/\s\s+/g, ' ');
      name = name.trim();
      var body = {
        "name": name,
        "type": 'NS'
      };
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.nameExist = data.response;
          }
        );
      this.disableName = false;
      nameElement.classList.add(...this.class);
    }
  }

  // Validation for NetIds
  validateId(id, index) {
    // Pattern validation
    this.patternError = false;
    let netIdRegExp = new RegExp(/^([0-9a-fA-F]{6})\/24$/i);
    if (!netIdRegExp.test(id)) {
      this.patternError = true;
      this.trackingPattern[index] = true;
    } else {
      this.patternError = false;
      this.trackingPattern[index] = false;
    }

    if(!this.patternError) {
      // Verify if NetId exists in database
      let headers = new HttpHeaders({'Content-Type': 'application/json'});
      let options = {headers: headers};
      var url = ApiEndpoints.EXISTS_NET_ID;
      var body: any = {
        "virtId": "0",
        "netId": id
      };
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.trackingArr[index] = data.response;
            this.hasError = this.trackingArr[index];
          }
      );
      // Verify if exists duplicates
      var prefixLength = parseInt(id.split("/")[1]);
      var prefix = this.hex2bin(id.split("/")[0]).substring(0, prefixLength)
      for (let i = 0; i < this.networkServerGroupModel.netIds.length; i++) {
        if (prefix == this.hex2bin(this.networkServerGroupModel.netIds[i]).substring(prefixLength) && i != index) {
          this.trackingCheck[index] = true;
          break;
        } else {
          this.trackingCheck[index] = false;
        }
      }
      this.duplicateError = this.trackingCheck[index];
    }

    // Verify if exists any error
    this.disableSaveButton = false;
    for(let i in this.trackingPattern) {
      if(this.trackingPattern[i] == true) {
        this.disableSaveButton = true;
      }
    }
    for(let i in this.trackingCheck) {
      if(this.trackingCheck[i] == true) {
        this.disableSaveButton = true;
      }
    }
    for(let i in this.trackingArr) {
      if(this.trackingArr[i] == true) {
        this.disableSaveButton = true;
      }
    }
  }

  // Validation on last NetID row
  validation(inputNetId) {
    this.noValid = this.hasError = this.duplicatesExist = this.duplicateError = this.netIdExist = false;

    if(inputNetId != "") {
      if(inputNetId.split("/").length == 1) inputNetId = inputNetId + '/24'
      let idRegExp = new RegExp(/^([0-9a-fA-F]{6})\/24$/i);
      if (!idRegExp.test(inputNetId)) {
        this.noValid = true;
      } else {
        this.noValid = false;
      }
      this.hasError = this.noValid;

      if(!this.noValid) {
        // Verify if NetId exists in database
        let headers = new HttpHeaders({'Content-Type': 'application/json'});
        let options = {headers: headers};
        var url = ApiEndpoints.EXISTS_NET_ID;
        var body: any = {
          "virtId": "0",
          "netId": inputNetId
        };
        this.http.post<any>(url, body, options).subscribe(
            data => {
              this.netIdExist = data.response;
              if (this.netIdExist == true) {
                this.hasError = true;
              } else {
                this.hasError = false;
              }
            }
          );

        // Verify if exists duplicates
        var prefixLength = parseInt(inputNetId.split("/")[1]);
        var prefix = this.hex2bin(inputNetId.split("/")[0]).substring(0, prefixLength)
        for (let i of this.networkServerGroupModel.netIds) {
          if (prefix == this.hex2bin(i).substring(0, prefixLength)) {
            this.duplicatesExist = true;
            break;
          } else {
            this.duplicatesExist = false;
          }
          this.duplicateError = this.duplicatesExist;
        }
      }
    }

    // Verify if exist at least one NetId
    this.doNotHaveNetId = false;
    if(this.networkServerGroupModel.netIds.length == 0 && inputNetId == "") {
      this.doNotHaveNetId = true;
    } else {
      this.doNotHaveNetId = false;
    }
  }

  addNetId(netId: string) {
    if (netId != null && netId != '') {
      if(netId.split("/").length == 1) netId = netId + '/24'
      this.networkServerGroupModel.addNetId(netId);
      let index = this.networkServerGroupModel.netIds.length - 1;

      this.trackingArr[index] = this.netIdExist;
      this.trackingCheck[index] = this.duplicatesExist;
      this.trackingPattern[index] = this.patternError;
      this.validateId(netId, index);
      this.noValid = this.netIdExist = this.hasError = this.duplicatesExist = this.doNotHaveNetId = false;
    }
  }

  trackByFn(index, item) {
    return index; // or item.id
  }

  editNetId(index, event) {
    this.networkServerGroupModel.editNetId(index, event.target.value);
  }

  removeNetId(firstInput, index) {
    this.noValid = this.netIdExist = this.hasError = this.duplicatesExist = this.disableSaveButton = this.patternError = this.doNotHaveNetId = false;
    this.trackingArr.splice(index, 1);
    this.trackingPattern.splice(index, 1);
    this.trackingCheck.splice(index,1);
    this.networkServerGroupModel.removeNetId(index);
    for(let validateIndex = 0; validateIndex <= this.trackingCheck.length; validateIndex++){
      if (this.trackingCheck[validateIndex] === true) {
        this.validateId(this.networkServerGroupModel.netIds[validateIndex], validateIndex);
      }
    }
    for(let validateIndex = 0; validateIndex <= this.trackingArr.length; validateIndex++){
      if (this.trackingArr[validateIndex] === true) {
        this.validateId(this.networkServerGroupModel.netIds[validateIndex], validateIndex);
      }
    }
    for(let validateIndex = 0; validateIndex <= this.trackingPattern.length; validateIndex++){
      if (this.trackingPattern[validateIndex] === true) {
        this.validateId(this.networkServerGroupModel.netIds[validateIndex], validateIndex);
      }
    }
    if(this.networkServerGroupModel.netIds.length == 0 && firstInput == "") {
      this.doNotHaveNetId = true;
    }
  }

  getAllOwnerWithSearch() {
    this.showSearch = true;
    var url = ApiEndpoints.GET_ALL_USERS;
    var body = {
      "username": ""
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'my-auth-token'
      })
    };
    this.http.post<Array<any>>(url, body, httpOptions).subscribe(
        data => {
          for(let index of data){
            if(index.isHidden == undefined || index.isHidden == "false") {
              this.ownerArray.push(index.username + ", " + index.firstName + " " + index.lastName);
            }
          }
        }
      );
  }

  // Get AllPrimaryHub Call Function
  getPlatform() {
    var url = ApiEndpoints.PLATFORMS;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'my-auth-token'
      })
    };
    this.http.post<Array<any>>(url, httpOptions).subscribe(
        data => {
          for(let index of data){
            this.allPlatforms.push(index.platformId + ", " + index.platformName);
          }
        }
      );
  }

  saveNetworkServerGroup() {
    this.networkServerGroupModel.name = this.networkServerGroupModel.name.trim();
    var body: any = JSON.parse(JSON.stringify(this.networkServerGroupModel));
    var url = ApiEndpoints.CREATE_NETWORK_SERVER_GROUP;
    this.http.post(url, body).subscribe(
        data => {
          this.router.navigate(['/all-network-groups']);
        }
      );
  }

  backClicked() {
    this._location.back();
  }

  sleep(milliseconds) {
    var start = new Date().getTime();
    for (var i = 0; i < 1e7; i++) {
      if ((new Date().getTime() - start) > milliseconds){
        break;
      }
    }
  }

  ngOnInit() {
    this.getAllOwnerWithSearch();
    $(document).ready(function () {
      $('.ui.dropdown')
        .dropdown({
          allowAdditions: true
        });
      });
  }

}
